import { keys } from 'lodash'

import { API_REGEX_PATH } from '~/constants'
import {
  EAdminPortalClientPath,
  EClientPath,
  EMarketingClientPath,
  EServerPath,
} from '~/models/api'

const pathBuilder = (
  templatePath:
    | EServerPath
    | EClientPath
    | EAdminPortalClientPath
    | EMarketingClientPath,
  params: { [k in string]: string | number } = {},
) => {
  const pathMatches = templatePath.match(API_REGEX_PATH)
  if (!pathMatches)
    throw new Error(`No matches found for the provided path: ${templatePath}`)
  const pathParams = pathMatches.map((match) => match.slice(1))
  // validating params
  keys(params).forEach((param) => {
    if (!pathParams.includes(param)) {
      throw new Error(`Param ${param} is not included!`)
    }
  })

  return pathMatches.reduce((acc, match) => {
    return acc.replace(match, params[match.slice(1)].toString())
  }, templatePath)
}

export default pathBuilder
